import React from "react"
import { useState } from 'react';

import RptMensualXEntidad from "./RptMensualXEntidad"
import RptMensualXRubro from "./RptMensualXRubro"
import RptMensualXMobilityApple from "./RptMensualXMobilityApple"
import RptAnualXTarifas from "./RptAnualXTarifas"
import RptAnualXIngresoTransportePer from "./RptAnualXIngresoTransportePer"
import RptAnualXQuintil from "./RptAnualXQuintil"
import RptAnualXQuintilPorcentaje from "./RptAnualXQuintilPorcentaje"
import RptAnualXRegistroVehicular from "./RptAnualXRegistroVehicular"
import RptAnualXRegistroVehicularXTipo from "./RptAnualXRegistroVehicularXTipo"
import ReactMarkdown from "react-markdown"


const Reports = (props) => {
  
    const [rpt, setRpt] =  useState("")//"MensualXEntidad");
    const [config, setConfig] =  useState({});

    const reportsConf = props.reportsConfig

    
    // let reports = [
        //     {key: 'MensualXEntidad', label: 'Mensual por Entidad', icon: 'flaticon-agendas'},
        //     {key: 'MensualXRubro', label: 'Mensual por Rubro', icon: 'flaticon-house'},
        //     {key: 'AnualXTarifas', label: 'Tarifas de transporte', icon: 'flaticon-analysis'},
        //     {key: 'AnualXIngresoTransportePer', label: 'Ingreso destinado a transporte (%)', icon: 'flaticon-notebook'}, // - order tracking
        //     {key: 'AnualXQuintil', label: 'Gastos e Ingresos por Quintil', icon: 'flaticon-notebook'}, // - order tracking
        //     {key: 'AnualXQuintilPorcentaje', label: 'Porcentaje de gasto en transporte', icon: 'flaticon-notebook'}, // - order tracking
        // ]
        
    let reports = reportsConf.map(rpt => { 
        return {key: rpt.basic_chart.config, label: rpt.title, icon: 'flaticon-analytics', caption: rpt.caption}
    })


    function onRptSelected(rpt, e){    
        setRpt(rpt.key);
        setConfig(rpt)
        if (e) e.preventDefault();
    }
    // onRptSelected(reports[0], null)

    return (
        <div>
        <div className="row">
            <div className="col-lg-12 col-md-12">

                <div className="row">

                {reports.map((item) => {
                    return (
                        <div className="col-lg-4 col-sm-6 col-md-6">
                            <a href="#!" onClick={(e) => onRptSelected(item, e) }>
                                <div className={`single-industries-serve-box small ${item.key==rpt ? "selected" : ""}`}>
                                    <div className="icon"><i className={`${item.icon}`}></i></div>
                                    {item.label}
                                </div>
                            </a>
                        </div>

                    )                 
                })}

                </div> 

            </div>
        </div>
        <div className="col-lg-12 col-md-12 report-caption" style={{visibility: config.caption!=null && config.caption!="" ? 'visible' : 'hidden' }}>
            <ReactMarkdown source={config.caption} />            
        </div>        
        <div className="row">
            <div className="col-lg-12 col-md-12">
                {rpt == 'MensualXEntidad' && <RptMensualXEntidad config={config}/>}
                {rpt == 'MensualXRubro' && <RptMensualXRubro/>}
                {rpt == 'MensualXMobilityApple' && <RptMensualXMobilityApple/>}
                {rpt == 'AnualXTarifas' && <RptAnualXTarifas/>}
                {rpt == 'AnualXIngresoTransportePer' && <RptAnualXIngresoTransportePer/>}
                {rpt == 'AnualXQuintil' && <RptAnualXQuintil/>}
                {rpt == 'AnualXQuintilPorcentaje' && <RptAnualXQuintilPorcentaje/>}
                {rpt == 'AnualXRegistroVehicular' && <RptAnualXRegistroVehicular/>}
                {rpt == 'AnualXRegistroVehicularXTipo' && <RptAnualXRegistroVehicularXTipo/>}
            </div>
        </div>
        </div>
    
    )
}



export default Reports
